import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'ghost' | 'danger' };

export function Button({ variant = 'primary', className, ...p }: Props) {
  return (
    <button
      className={clsx('rounded-xl px-4 py-2 text-sm font-semibold disabled:opacity-50', variant === 'primary' && 'bg-brand-600 text-white hover:bg-brand-800', variant === 'ghost' && 'border border-slate-200 text-navy bg-white', variant === 'danger' && 'bg-red-600 text-white', className)}
      {...p}
    />
  );
}
